import API from "../API";
import { AxiosResponse } from "axios";

export const listGroup = (search: string): Promise<AxiosResponse> =>
  API.get(`/group/list?search=${search}`);

export const listGroupById = (id: string): Promise<AxiosResponse> =>
  API.get(`/group/list/${id}`);

export const enabledDisabledGroup = (id: string): Promise<AxiosResponse> =>
  API.post(`/group/deactivate/${id}`);
